import { PortalApp } from './portal/PortalApp';

/**
 * App — mobil webview, embeddet i PARK-appen.
 * Entry: /portal?token=<portal-token> (veksles til en session-cookie ved opstart).
 * Intern navigation er stack-baseret
 * (se src/portal/navigation.ts). INGEN Service Worker / PWA.
 */
function App() {
  return <PortalApp />;
}

export default App;
